import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageSenderComponent } from './message-sender/message-sender.component';
import { ThemePickerComponent } from './theme-picker/theme-picker.component';
import { SecretComponent } from './secret/secret.component';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    MessageSenderComponent,
    SecretComponent,
    ThemePickerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [MessageSenderComponent, SecretComponent, ThemePickerComponent]
})
export class PortalDevModule { }
